import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
// 国际化
import i18n from './vue-i18n/vue-i18n';

// Element
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// global css
import '@/styles/index.less';

// 注册全局filter
import * as filters from './filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.use(Element, {
  size: 'small',
  i18n: (key: string, value: string) => i18n.t(key, value)
});

Vue.config.productionTip = false;

(window as any).vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
});
(window as any).vm.$mount('#app');
